<template>
  <div class="small">
    <pie-chart
      v-if="showChart"
      :styles="{height: '200px'}"
      :chart-data="datacollection"
      :options="chartOptions"
    />
    <div
      v-else
      class="chart-widget-blank d-flex flex-column align-items-center justify-content-center mt-5"
    >
      <div class="mt-2">
        <i
          class="far fa-chart-pie-alt fa-3x"
          aria-hidden="true"
        />
      </div>
      <span class="text-center mt-4">
        {{ $t('dashboard.widget.pendingCasesEmptyStateText') }}
      </span>
    </div>
  </div>
</template>

<script>
import dashboardService, { DASHBOARD_SITUATION_CASE_OPTIONS } from '@/api/resources/dashboard/dashboardService'
import Encoder from '@/utils/encoder'
import PieChart from '@/modules/dashboardModule/widgets/chartWidget/PieChart'

export default {
    components: {
        PieChart
    },
    props: {
        caseDelaySummary: { type: String }
    },
    data() {
        return {
            datacollection: null,
            chartOptions: null,
            delayedData: null,
            encoder: new Encoder(),
            labels: [],
            data: [],
            backgroundColor: []
        }
    },
    computed: {
        showChart() {
            return this.datacollection?.datasets?.[0]?.data?.reduce((a, b) => a + b, 0) !== 0
        }
    },
    mounted() {
        this.chartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            }
        }
    },
    methods: {
        async fillData(filter, caseTypeSituation) {
            this.clearFields()
            const relativeHourIntervals = {
                '0-48h': {
                    'fromHour': -48,
                    'toHour': 0
                },
                '48h-72h': {
                    'fromHour': -72,
                    'toHour': -48
                },
                '3d-7d': {
                    'fromHour': -168,
                    'toHour': -72
                },
                '7d-15d': {
                    'fromHour': -360,
                    'toHour': -168
                },
                '15d-30d': {
                    'fromHour': -720,
                    'toHour': -360
                },
                '>30d': {
                    'fromHour': null,
                    'toHour': -720
                }
            }

            this.updateLoading(true)
            const [error, response] = await this.toCall(dashboardService.getSummaryCaseDelayed(caseTypeSituation || DASHBOARD_SITUATION_CASE_OPTIONS.ALL_PENDING_DASHBOARD.key, filter, relativeHourIntervals, this.caseDelaySummary))
            if (error) {
                this.showErrorModalGlobal()
                this.updateLoading(false)
                return
            }
            Object.keys(response).forEach(key => {
                this.labels.push(response[key].entity)
                this.data.push(response[key].count)
                this.backgroundColor.push(this.getRandColor(4))
            })
            this.datacollection = {
                labels: this.labels,
                datasets: [
                    {
                        data: this.data,
                        backgroundColor: this.backgroundColor
                    }
                ]
            }
            this.updateLoading(false)
        },
        getRandColor(brightness) {
            const rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256]
            const mix = [brightness * 51, brightness * 51, brightness * 51]
            const mixedRGB = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]].map(function(x) { return Math.round(x / 2.0) })
            return 'rgb(' + mixedRGB.join(',') + ')'
        },
        clearFields() {
            this.labels = []
            this.data = []
            this.backgroundColor = []
        }
    }
}
</script>

<style>
</style>
